import $ from 'jquery';

import 'select2';
import 'typeahead';
import 'jssocials';
import 'matchHeight'


import hoverIntent   from 'hoverIntent-jqplugin';
import slick         from 'slick-carousel';
import scrollMonitor from 'scrollmonitor';
import TweenMax      from 'gsap';
import fancybox      from 'fancybox';
import helpers       from 'helpers';

import IssueHeader   from '../_modules/issue/issueheader/issueheader';
import Search        from '../_modules/search/search';
import LoadMore      from '../_modules/loadMore/loadMore';
import Video         from '../_modules/video/video';
import Sitemap       from '../_modules/sitemap/sitemap';

$(() => {
	'use strict';

	//global
	var winsize=$(window).width();
	hoverIntent($);

	const search = new Search();
	const issueheader = new IssueHeader();
	const loadMore = new LoadMore();
	const video = new Video();
    const sitemap = new Sitemap();

    const $searchIcon = $('.header__search-icon'),
        $toggleSearchIcon = $searchIcon.find('.icon'),
        $searchContainer = $('.header__search-container');


	//mobile menu
	$('.mobile-menu').on('click',function(){
	 if(winsize>767) return false;
	 var $this=$(this),
		 $mobileNav=$('nav.mobile-primary-nav');

	 if($mobileNav.hasClass('expanded')){
		 $mobileNav.slideUp().removeClass('expanded');
		 $this.removeClass('expanded');

	 }else{
		 $mobileNav.slideDown().addClass('expanded');
		 $this.addClass('expanded');
	 }
	});

	//matchHeight
	$('.match-height, .issues-list li').matchHeight();


	//accordion
	$('.js-acc-header').on('click',function(){
	 if(winsize>1023) return false;
	 var $this=$(this),
		 $accTarget=$this.next('.js-acc-body');

	 if($accTarget.hasClass('expanded')){
		 $accTarget.slideUp().removeClass('expanded');
		 $this.removeClass('expanded');

	 }else{
		 $accTarget.slideDown().addClass('expanded');
		 $this.addClass('expanded');

		 $('html, body').animate({
			 scrollTop: $this.offset().top
		 }, 500);
	 }
	});

	//nudge prev next hint
	$('.issue-pager__prev').hoverIntent(
	 function(){
		 $('.issue-body').addClass('nudge-prev');
	 },
	 function(){
		 $('.issue-body').removeClass('nudge-prev');
	 });

	$('.issue-pager__next').hoverIntent(
	 function(){
		 $('.issue-body').addClass('nudge-next');
	 },
	 function(){
		 $('.issue-body').removeClass('nudge-next');
	 });

	//prev next positioning

	var myElement = $('header.main');

	var elementWatcher = scrollMonitor.create( myElement );

	elementWatcher.enterViewport(function() {
	 $('aside.issue-pager').addClass('fixed');
	});
	elementWatcher.exitViewport(function() {
	 $('aside.issue-pager').removeClass('fixed');
	});

	//highlights carousel
	$('.carousel.enabled').each(function(){
	 var $this=$(this),
		 $pager=$this.next('.carousel-nav');


	 $this.slick({
		 autoplay:true,
		 autoplaySpeed:5000,
		 pauseOnHover:true,
		 prevArrow:$('.carousel-nav__prev'),
		 nextArrow:$('.carousel-nav__next')
	 });

	});

	//desktop animation
	//todo: need to make it DRY
	if(winsize>1023){
	 var $factsPanels=$('.issue-facts.issue_section');
	 var elementWatcher1 = scrollMonitor.create($factsPanels);
		 elementWatcher1.enterViewport(function() {
			 TweenMax.staggerTo( $('.issue-facts.issue_section li'), 0.75, { opacity: 1, left: 0, ease: Expo.easeOut, delay: 0.25 }, 0.1 );
		 });

	 var $videoSection=$('.issue-video.issue_section');
		 $videoSection.css({ opacity: 0, top: '20px', position:'relative'});
	 var elementWatcher2 = scrollMonitor.create($videoSection);
		 elementWatcher2.enterViewport(function() {
			 TweenMax.staggerTo( $videoSection, 0.75, { opacity: 1, top: 0, ease: Expo.easeOut, delay: 0.5 }, 0.1 );
		 });

	 var $columnPanels=$('.issue-lifestyle.issue_section,.issue-conservation.issue_section,.issue-gardening.issue_section');
		 $columnPanels.css({ opacity: 0, top: '20px', position:'relative'});
	 var elementWatcher3 = scrollMonitor.create($columnPanels);
		 elementWatcher3.enterViewport(function() {
			 TweenMax.staggerTo( $columnPanels, 0.75, { opacity: 1, top: 0, ease: Expo.easeOut, delay: 0.5 }, 0.1 );
		 });

	 var $editorPanels=$('.issue-editorial.issue-footer ');
		 $('.editors-note,.editorial-team',$editorPanels).css({ opacity: 0, top: '20px'});
	 var elementWatcher4 = scrollMonitor.create($editorPanels);
		 elementWatcher4.enterViewport(function() {
			 TweenMax.staggerTo( $('.editors-note,.editorial-team',$editorPanels), 0.75, { opacity: 1, top: 0, ease: Expo.easeOut, delay: 0.5 }, 0.1 );
		 });

	 var $credits=$('footer.main .credits');
		 $('footer.main').css({ overflow: 'hidden'});
		//  $credits.css({ bottom: '-100px'});
	//  var elementWatcher5 = scrollMonitor.create($('footer.main'));
	// 	 elementWatcher5.enterViewport(function() {
	// 		 TweenMax.staggerTo( $credits, 0.5, { bottom: '20px', ease: Expo.easeOut, delay: 0.5}, 0.1 );
	// 	 });
	}
	if($("#shareIcons").length > 0)
	$("#shareIcons").jsSocials({
		showLabel: false,
		showCount: false,
		shareIn: 'popup',
		shares: [
		 {
			 share: "facebook",
			 label: "Share",
			 logo: "icon icon-facebook-f"
		 },
		 {
			 share: "twitter",
			 label: "Tweet",
			 logo: "icon icon-twitter"
		 }
	 ]
	});



	/* =========================================================
	>> Font resizer
	============================================================ */
	let $fontResizer = $('.js-resizer');
	//change font size
	$fontResizer.on('click', function(e) {
		e.preventDefault();

		let size = $(this).data('size');

		$fontResizer.removeClass('is-active');
		$(this).addClass('is-active');

		if (size == 'normal') {
			$('#mainContent').removeClass('font-large').removeClass('font-larger').addClass('font-normal');
		} else if (size == 'big') {
			$('#mainContent').removeClass('font-larger').removeClass('font-normal').addClass('font-large');
		} else if (size == 'bigger') {
			$('#mainContent').removeClass('font-normal').removeClass('font-large').addClass('font-larger');
		}

		// reset matchheight elements after font resize
		$.fn.matchHeight._update();

	});

	if($('.issue-selector select').length > 0)
	$('.issue-selector select').select2({
	 minimumResultsForSearch: Infinity,
	 theme: "classic"
	});

	$(window).resize(function(){
	 winsize=$(window).width(); //update winsize on resize
    });

    //google custom search
    function getUrlParameter(param) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;

		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');


			if (sParameterName[0] === param) {
				return sParameterName[1] === undefined ? true : sParameterName[1];
			}
		}
    }

    if($('.search-container').length) {
        let value = getUrlParameter('q');
        if(getUrlParameter('q') !== undefined) {

            var paramValue = getUrlParameter('q').split('+').join(' ');
            var cxValue = getUrlParameter('cx') !== undefined ? getUrlParameter('cx').split('+').join(' ') : 'all';

            if(cxValue) {
                $('.listing-body').addClass('hide');
                $('.search-container').removeClass('hide');
                $('.issue-header h1').text('You were looking for '+paramValue);
            }
        }

    }

    $searchIcon.on('click', function(e) {
		e.preventDefault();
		$searchContainer.toggleClass('open');

		if ($searchContainer.hasClass('open')) {
			$toggleSearchIcon.removeClass('icon-search').addClass('icon-close');
		} else {
			$toggleSearchIcon.removeClass('icon-close').addClass('icon-search');
		}
	});


	// sitecore webform hacks
	$('#wffm27b3c550db1f41019efd687cd8955e80_Sections_0__Fields_3__Value').parent().hide();

});
